export const version = "ethers/5.7.2";
//# sourceMappingURL=_version.js.map